//WE.Flow.Html.Contracts.Manifests.ManifestConstants

export class ManifestConstants {
    public static readonly ToolbarItemOrderDefaultValue: number = 999999;
    public static readonly ToolbarItemOrderMaxValue: number = 1000000;
    public static readonly ToolbarItemOrderHomeValue: number = 1;
    public static readonly ToolbarItemOrderConfigValue: number = 2147483647;
}
